// customerLocationData.js
// Static location data for the customer form
// Currently supports Karnataka → Udupi, Mysuru, DakshinaKannada, Chikkamagaluru, Hassan, Kodagu

export const INDIAN_STATES = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  "Delhi",
  "Jammu and Kashmir",
  "Ladakh",
  "Puducherry",
];

// For now only Karnataka → these districts are active in the UI
export const STATE_DISTRICTS = {
  Karnataka: ["Udupi", "Mysuru", "Mandya", "Shivamogga", "UttaraKannada","DakshinaKannada",
    "Chikkamagaluru",
    "Hassan",
    "Kodagu"],
};

// District → Taluk list
export const DISTRICT_TALUKS = {
  Udupi: [
    "Brahmavara",
    "Byndoor",
    "Hebri",
    "Kaup",
    "Karkala",
    "Kundapura",
    "Udupi",
  ],
  Mysuru: [
    "Heggadedevankote",
    "Hunsur",
    "Krishnarajanagara",
    "Mysuru",
    "Nanjangud",
    "Piriyapatna",
    "Saligrama",
    "Saraguru",
    "Tirumakudal-narsipur",
  ],

  Mandya: [
    "Krishnarajpet",
    "Maddur",
    "Malvalli",
    "Mandya",
    "Nagamangala",
    "Pandavapura",
    "Shrirangapattana"
  ],
  Shivamogga: [
    "Bhadravati",
    "Hosanagara",
    "Sagar",
    "Shikarpur",
    "Shivamogga",
    "Sorab",
    "Tirthahalli"
  ],
  UttaraKannada:[
  "Ankola",
  "Bhatkal",
  "Dandeli",
  "Haliyal",
  "Honavar",
  "Karwar",
  "Kumta",
  "Mundgod",
  "Siddapur",
  "Sirsi",
  "Supa",
  "Yellapur"
],
 DakshinaKannada: [
    "Bantval",
    "Beltangadi",
    "Kadaba",
    "Mangaluru",
    "Mudubidare",
    "Mulki",
    "Puttur",
    "Sulya",
    "Ullala",
  ],
  Chikkamagaluru: [
    "Ajjampura",
    "Chikkamagaluru",
    "Kadur",
    "Kalasa",
    "Koppa",
    "Mudigere",
    "Narasimharajapura",
    "Sringeri",
    "Tarikere",
  ],
  Hassan: [
    "Alur",
    "Arkalgud",
    "Arsikere",
    "Belur",
    "Channarayapatna",
    "Hassan",
    "Holenarsipur",
    "Sakaleshpur",
  ],
  Kodagu: [
    "Kushalanagar",
    "Madikeri",
    "Ponnampet",
    "Somvarpet",
    "Virajpet",
  ],

};

// Taluk → Panchayat list (names only)
export const TALUK_PANCHAYATS = {
  // ===== Udupi District =====
  Brahmavara: [
    "Kalathur",
    "Aroor",
    "Avarse",
    "Barkur",
    "Billadi",
    "Chantharu",
    "Cherkadi",
    "Handadi",
    "Hanehalli",
    "Haradi",
    "Havanje",
    "Heggunje",
    "Irodi",
    "Kadur",
    "Karje",
    "Kodi",
    "Kokkarne",
    "Kota",
    "Kotathattu",
    "Nalkur",
    "Neelavara",
    "Pandeshwara",
    "Shiriyara",
    "Uppoor",
    "Vaddarse",
    "Varamballi",
    "Yadthadi",
  ],

  Byndoor: [
    "Bijooru",
    "Golihole",
    "Hallihole",
    "Herooru",
    "Jadkal",
    "Kalthodu",
    "Kambadakone",
    "Kergal",
    "Kirimanjeshwara",
    "Kolluru",
    "Maravanthe",
    "Nada",
    "Navunda",
    "Shiruru",
    "Uppunda",
  ],

  Hebri: [
    "Belve",
    "Chara",
    "Hebri",
    "Kuchchuru",
    "Madamakki",
    "Mudradi",
    "Nadpalu",
    "Shivapura",
    "Varanga",
  ],

  Kaup: [
    "Bada",
    "Belapu",
    "Belle",
    "Hejamadi",
    "Innanje",
    "Katapadi",
    "Kote",
    "Kurkalu",
    "Kuthyaru",
    "Majur",
    "Mudarangadi",
    "Padubidri",
    "Palimaru",
    "Shirva",
    "Thenka",
    "Yellur",
  ],

  Karkala: [
    "Bailoor",
    "Belman",
    "Bola",
    "Durga",
    "Erlapadi",
    "Hirgana",
    "Idu",
    "Inna",
    "Irvathauru",
    "Kadthala",
    "Kalya",
    "Kanthavara",
    "Kervashe",
    "Kukkundoor",
    "Mala",
    "Marne",
    "Miyaru",
    "Mudaru",
    "Mundkoor",
    "Nalloor",
    "Nandalike",
    "Neere",
    "Nitte",
    "Palli",
    "Renjala",
    "Sanoor",
    "Shirlal",
  ],

  Kundapura: [
    "Ajri",
    "Aluru",
    "Amasbail",
    "Amparu",
    "Anagali",
    "Balkuru",
    "Basruru",
    "Belooru",
    "Bijadi",
    "Chitturu",
    "Gangolli",
    "Gopadi",
    "Gujjadi",
    "Gulwadi",
    "Hakladi",
    "Haladi",
    "Hambadi-mandadi",
    "Hangluru",
    "Hardalli-mandalli",
    "Hattiangadi",
    "Hemmadi",
    "Hengavalli",
    "Hosaadu",
    "Hosangadi",
    "Iduru Kunjyadi",
    "Kalavara",
    "Kandavara",
    "Karkunje",
    "Kattabelthuru",
    "Kavradi",
    "Keduru",
    "Keradi",
    "Koni",
    "Korgi",
    "Koteshwara",
    "Kumbashi",
    "Molahalli",
    "Shankaranarayana",
    "Siddapura",
    "Talluru",
    "Tekkatte",
    "Trasi",
    "Ullur",
    "Vandse",
    "Yedamogge",
  ],

  Udupi: [
    "Badagubettu",
    "Alevoor",
    "Ambalapadi",
    "Athradi",
    "Badanidiyur",
    "Bairampalli",
    "Bommarabettu",
    "Kadekaru",
    "Kalyanpura",
    "Kemmannu",
    "Kodibettu",
    "Kukkehalli",
    "Manipura",
    "Perdoor",
    "Thenkanidiyur",
    "Udyavara",
    "Rosette",
  ],

  // ===== Mysuru District =====

  Heggadedevankote: [
    "Alanahalli",
    "Annur",
    "Antharasanthe",
    "Bachegowdanahalli",
    "Beechanahalli",
    "Bheemanahalli",
    "Chakkodanahalli",
    "Chikkereyuru",
    "D.b.kuppe",
    "G.b.saragur",
    "Hampapura",
    "Hebbalaguppe",
    "Hirehalli",
    "Hommaragalli",
    "Hosaholalu",
    "Hyrige",
    "Kanchamalli",
    "Kyathanahalli",
    "Madapura",
    "N.begur",
    "N.belthur",
    "Naganahalli",
    "Nooralakuppe",
    "Padukote Kaval",
    "Savve",
    "Thumbasoge",
  ],

  Hunsur: [
    "Aspathrekaval",
    "Bannikuppe",
    "Beejaganahalli",
    "Biligere",
    "Bilikere",
    "Bolanahalli",
    "Challahalli",
    "Chikkabeechanahalli",
    "Chilkunda",
    "Dharmapura",
    "Dodda Hejjur",
    "Gagenahalli",
    "Gavadagere",
    "Govindanahalli",
    "Gurupur",
    "Halebeedu",
    "Hanagodu",
    "Harave",
    "Hegganduru",
    "Hirikyathanahalli",
    "Husenpura",
    "Jabagere",
    "Kademanuganhalli",
    "Kallahalli",
    "Karanakuppe",
    "Karimuddanahalli",
    "Kattemalalavadi",
    "Kiranguru",
    "Kothegala",
    "Manuganahalli",
    "Maradur",
    "Moduru",
    "Mukanhalli",
    "Mulluru",
    "Neralakuppe",
    "Singaramaranahalli",
    "Thattekere",
    "Uddur Kaval",
    "Udduru",
    "Ummathur",
    "Uyyigowdanahalli",
  ],

  Krishnarajanagara: [
    "Adagur",
    "Arjunahalli",
    "Byadarahally",
    "Chandagalu",
    "Doranahally(doddakoppalu)",
    "Gandhanahally",
    "Hebbalu",
    "Hompapura",
    "Hosaagrahara",
    "Kaggere",
    "Kesthur",
    "Lalandevanahally",
    "Mavattur",
    "Saligrama",
    "Siddapura",
    "Thippur",
  ],

  Mysuru: [
    "Alanahalli",
    "Anandur",
    "Birihundi",
    "Chamundibetta",
    "Devalapura",
    "Dhanagalli",
    "Doddamaragowdanahalli",
    "Doora",
    "Gopalapura",
    "Gungaralachathra",
    "Harohalli",
    "Harohalli (mallahalli)",
    "Jayapura",
    "Keelanapura",
    "Marballi",
    "Mosambayanahalli",
    "Naganahalli",
    "Nagawala",
    "Siddalingapura",
    "Sindhuvalli",
    "Someshwarapura",
    "Udbur",
    "Vajamangala",
    "Varakodu",
    "Varuna",
    "Yadakola",
    "Yelawala",
  ],

  Nanjangud: [
    "Badanavalu",
    "Biligere",
    "Dasanur",
    "Deburu",
    "Devanur",
    "Devarasanahalli",
    "Devarayashettypura",
    "Deviramanahalli",
    "Doddakowlande",
    "Duggahalli",
    "Hadinaru",
    "Hadya",
    "Haginavalu",
    "Hallare",
    "Haradanahalli",
    "Hedathale",
    "Hediyala",
    "Heggadahalli",
    "Hemmaragala",
    "Horalavadi",
    "Hosakote",
    "Hulimavu",
    "Hullahalli",
    "Hura",
    "Kalale",
    "Karya",
    "Kasuvinahalli",
    "Kempesiddana Hundi",
    "Konanur",
    "Kudalapura",
    "Kurihundi",
    "Mallupura",
    "Maraluru",
    "Nagarle",
    "Nallethalapura",
    "Naviluru",
    "Nerale",
    "Rampura",
    "Shiramalli",
    "Sinduvalli",
    "Suthur",
    "Tagadur",
    "Thandavapura",
    "Thayuru",
    "Thumnerale",
  ],

  Piriyapatna: [
    "Attigodu",
    "Avarthi",
    "Bettadapura",
    "Bettadatunga",
    "Bhuvanahalli",
    "Bylakuppe",
    "Chapparadahalli",
    "Chennakalkavalu",
    "Chikkanerale",
    "Chittenahalli",
    "Chowthi",
    "Doddabylalu",
    "Doddakamaravalli",
    "Halaganahalli",
    "Handithavalli",
    "Haraduru",
    "Haranahalli",
    "Hitnehebbagilu",
    "Hunasavadi",
    "Kampalapura",
    "Kanagalu",
    "Kirnalli",
    "Kittur",
    "Komalapura",
    "Koppa",
    "Makodu",
    "Malangi",
    "Muttur",
    "N. Shettihalli",
    "Naviluru",
    "Panchavlli",
    "Punadahalli",
    "Ramanathatunga",
    "Ravandoor",
  ],

  Saligrama: [
    "Ankanahally",
    "Bheriya",
    "Channamgere",
    "Haliyur",
    "Hanasoge",
    "Haradanahally",
    "Honnenahally",
    "Hosakote",
    "Karpoorvally",
    "Kuppehantha(chunchanakatte)",
    "Lakshmipura",
    "Mayigowdanahally",
    "Melur",
    "Mirle",
    "Munjanahally",
    "Narachanahally",
    "Sheegavalu",
    "Thandre",
  ],

  Saraguru: [
    "B.matakere",
    "Bidarahalli",
    "Hadanuru",
    "Hanchipura",
    "Hegganur",
    "Itna",
    "K.belthur",
    "Kallambalu",
    "Kothegala",
    "M.c.thalalu",
    "Manuganahalli",
    "Mullur",
    "Sagare",
  ],

  "Tirumakudal-narsipur": [
    "Ankanahalli",
    "Attahalli",
    "B.shettahalli",
    "Beedanahalli",
    "Benakanahalli",
    "Chidaravalli",
    "Doddebagilu",
    "Gargeshwari",
    "Hanumanalu",
    "Hegguru",
    "Hemmige",
    "Holesalu",
    "Hosakote",
    "Kaliyuru",
    "Karohatti",
    "Kethupura",
    "Kiragasuru",
    "Kodagahalli",
    "Kolathuru",
    "Kothegala",
    "Kupya",
    "Madapura",
    "Maliyuru",
    "Muguru",
    "Muttalavadi",
    "Rangasamudra",
    "Seehalli",
    "Somanathapura",
    "Sosale",
    "T.doddapura",
    "Talkad",
    "Thumbala",
    "Thuraganuru",
    "Ukkalagere",
    "Vatalu",
    "Yachenahalli",
  ],

  Krishnarajpet: [
    "Aghalaya",
    "Agraharabachahalli",
    "Aikanahalli",
    "Akkihebbalu",
    "Alambadi Kaval",
    "Anagola",
    "Ballekere",
    "Ballenahalli",
    "Bandihole",
    "Beeruvalli",
    "Bharathipuracross",
    "Bookanakere",
    "Chowdenahalli",
    "Dabbegatta",
    "Ganjigere",
    "Haralahalli",
    "Hariharapura",
    "Hirikalale",
    "Ichanahalli",
    "Kikkeri",
    "Lakshmi Pura",
    "Madapura",
    "Maduvina Kodi",
    "Makavalli",
    "Mandagere",
    "Murukanahalli",
    "Ranganathapura Cross",
    "Santhebachahalli",
    "Sarangi",
    "Shilanere",
    "Sindhagatta",
    "Somanahalli",
    "Tendekere",
    "Vitalapura"
  ],

  Maddur: [
    "Abalavadi",
    "Aluru",
    "Annuru",
    "Athaguru",
    "Bekkalale",
    "Besagarahalli",
    "Bharathinagar",
    "Bidarahalli",
    "Bidharakote",
    "Chamanahalli",
    "Chikkarasinakere",
    "Doddarasinakare",
    "Gejjalagere",
    "Goravanahalli",
    "Hemmanahalli",
    "Hosagavi",
    "Hosakere",
    "Huthagere",
    "K Honnalagere",
    "K. Bellur",
    "K. Shettahalli",
    "Kadhalur",
    "Kadukottanahalli",
    "Kesthuru",
    "Koolagere",
    "Koppa",
    "Koudle",
    "Kyathaghatta",
    "Madharahalli",
    "Mallana Kuppe",
    "Maraliga",
    "Menasagere",
    "Nagarakere",
    "Nidaghatta",
    "Niluvagilu",
    "S I Honnalagere",
    "Sadolalu",
    "Somanahalli",
    "Thaggahalli",
    "Torebommanahalli",
    "Valagerehalli",
    "Yadaganahalli"
  ],

  Malvalli: [
    "Agasnapura",
    "B.g.pura",
    "Bandur",
    "Belakavadi",
    "Bendaravadi",
    "Bydarahalli",
    "Chikkamulagudu",
    "Chottenahalli",
    "D.halasahalli",
    "Dalavayikodihalli",
    "Dhanaguru",
    "Dugganahalli",
    "H Basavapura",
    "Haadli",
    "Halaguru",
    "Hittanahalli",
    "Hosahalli",
    "Huskur",
    "Kaggalipura",
    "Kalkuni",
    "Kandegala",
    "Kirugavalu",
    "Kundur",
    "Kyathnahalli",
    "Lingapatna",
    "Marehalli",
    "Mikkere",
    "Nelamakanahalli",
    "Nidaghatta",
    "Nitturu",
    "Pandithahalli",
    "Purigali",
    "Ragibommanahalli",
    "Sarguru",
    "Settihalli",
    "Sujjalur",
    "Talagavadi",
    "Thorekadanahalli",
    "Yathambadi"
  ],

  Mandya: [
    "Alakere",
    "B.gowdagere",
    "B.hosur",
    "Baby",
    "Basaralu",
    "Belur",
    "Bevinahalli",
    "Bevukal",
    "Boodanur",
    "Chandagalu",
    "Chandagalu (dudda)",
    "Doddagarudanahalli",
    "Dudda",
    "G.malligere",
    "Ganadalu",
    "Gopalapura",
    "H.malligere",
    "Hallegere",
    "Haluvadi",
    "Hanakere",
    "Hodaghatta",
    "Holalu",
    "Hulivana",
    "Hullenahalli",
    "Induvalu",
    "Kambadahalli",
    "Kannali",
    "Keelara",
    "Kereagodu",
    "Kothathi",
    "Mandya Rural",
    "Mangala",
    "Maragowdanahalli",
    "Marchakanahally",
    "Mudagandur",
    "Muthegere",
    "Santhekasalagere",
    "Sathanoor",
    "Shivalli",
    "Shivapura",
    "Soonagahalli",
    "Thaggahalli",
    "Tubinakere (yelechakanahalli)",
    "Ummadahalli",
    "Upparakanahalli",
    "Yaliyur",
  ],

  Nagamangala: [
    "Anchechittanahalli",
    "Arani",
    "Bhimanahalli",
    "Bhramhadevarahalli",
    "Bindiganavile",
    "Bogadhi",
    "Chinya",
    "Chunchanahalli",
    "Devalapura",
    "Devaramallanayakanahalli",
    "Doddabala",
    "Gondenahalli",
    "Haradanahalli",
    "Honakere",
    "Honnavara",
    "Hulikere",
    "Javaranahalli",
    "Kadabahalli",
    "Kalinganahalli",
    "Kanthapura",
    "Karadahalli",
    "Lalanakere",
    "Mannahalli",
    "Mayigonahalli",
    "Nalligere",
    "Palagrahara",
    "Tuppadamadu"
  ],

  Pandavapura: [
    "Aralakuppe",
    "Balagatta",
    "Bannangadi",
    "Chikkade",
    "Chinakurali",
    "Dinka",
    "Doddabyadarahalli",
    "Gummanahalli",
    "Halebeedu",
    "Haravoo",
    "Hiremarali",
    "Honaganahalli",
    "Jakkanahalli",
    "K Bettahalli",
    "Kanagana Maradi",
    "Katteri",
    "Kennalu",
    "Kyathanahalli",
    "Lakshmi Sagara",
    "Manikana Halli",
    "Melukote",
    "Narayanapura",
    "Sunkatonnur",
    "T.s. Chatra"
  ],

  Shrirangapattana: [
    "Arakere",
    "Ballekere",
    "Ballenahalli",
    "Belagola",
    "Chikkaankanahalli",
    "Darasaguppe",
    "Gamanahalli",
    "Hosahalli",
    "Hulikere",
    "K.r.sagara",
    "K.shettahalli",
    "Kirangur",
    "Kodiyala",
    "Mahadevapura",
    "Melapura",
    "Mundugadore",
    "Naguvanahalli",
    "Palahalli",
    "Sabbanakuppe",
    "T.m.hosur",
    "Thadagavadi"
  ],

  Bhadravati:[

  "Agaradahalli",
  "Anaveri",
  "Antharagange",
  "Arahatholalu",
  "Arakere",
  "Aralahalli",
  "Aralikoppa",
  "Arebilachi",
  "Attigunda",
  "Baranduru",
  "Bilaki",
  "Dasarakallahalli",
  "Dodderi",
  "Donabagatta",
  "Gudumagatta",
  "Hanumanthapura",
  "Hiriyuru",
  "Kagekodamaggi",
  "Kallahal",
  "Kallahalli",
  "Kambadalu Hosuru",
  "Karehalli",
  "Kudligere",
  "Kummaranahalli",
  "Mangote",
  "Marashettyhalli",
  "Mavinakere",
  "Mydolalu",
  "Nagathibelagalu",
  "Nimbegondi",
  "Sanyasikodamagge",
  "Sidlipura",
  "Singanamane",
  "Sydarakallahalli",
  "Tavaragatta",
  "Thadasa",
  "Veerapura",
  "Yedehalli",
  "Yerehalli"
  ],

  Hosanagara:[
  "Amrutha",
  "Andagadhudhuru",
  "Aramanekoppa",
  "Arasalu",
  "Baluru",
  "Belluru",
  "Chikkajeni",
  "Harathalu",
  "Haridravathi",
  "Heddharipura",
  "Hosuru(sampekatte)",
  "Humcha",
  "Jeni",
  "Kairagunda",
  "Karimane",
  "Kenchanala",
  "Koduru",
  "M.guddekoppa",
  "Maruthipura",
  "Melinabesige",
  "Mudugoppa-nagara",
  "Mumbaru",
  "Nitturu",
  "Purappemane",
  "Ramachandrapura",
  "Reppanpete",
  "Sonale",
  "Sulagodu",
  "Trinive",
  "Yaduru"
],

Sagar:[
  "Achapura",
  "Anandapura",
  "Aralagodu",
  "Avinahalli",
  "Banukuli",
  "Baruru",
  "Bhimanakone",
  "Bhimaneri",
  "Channagonda",
  "Gowthamapura",
  "Heggodu",
  "Herenelluru",
  "Hirebilagunji",
  "Hosuru",
  "Kalmane",
  "Kandika",
  "Kanle",
  "Keladi",
  "Koluru",
  "Kudaruru",
  "Malve",
  "Maratturu",
  "Masuru",
  "Nadakalasi",
  "Padavagodu",
  "Sannashanubhog",
  "Shiravanthe",
  "Syduru",
  "Talaguppa",
  "Talavata",
  "Tumari",
  "Tyagarthi",
  "Ulluru",
  "Yadajigalemane",
  "Yadehalli"
]
,
Shikarpur:
[
  "Amatekoppa",
  "Ambaragoppa",
  "Arasinagere",
  "Baganakatte",
  "Beguru",
  "Belagavi",
  "Bilaki",
  "Chikkajamburu",
  "Chikkamagadi",
  "Churchugundi",
  "Esuru",
  "Gama",
  "Goddanakoppa",
  "Gogga",
  "Guddadathummenakatte",
  "Harigi",
  "Harogoppa",
  "Herejamburu",
  "Hittala",
  "Hosuru",
  "Hothana Katte",
  "Inam Agraharamuchadi",
  "Jakkanahalli",
  "Jakkinakoppa",
  "Kaginalli",
  "Kalmane",
  "Kappanahalli",
  "Kittadahalli",
  "Koratigere",
  "Malavalli",
  "Manchikoppa",
  "Maravalli",
  "Mattikote",
  "Muddanahalli",
  "Mudubasiddapura",
  "Narasapura",
  "Nelavagilu",
  "Saluru",
  "Sunnadakoppa",
  "Thalagunda",
  "Tharalagatta",
  "Thogarsi",
  "Udagani"
],

Shivamogga:[
  "Abbalagere",
  "Agasavalli",
  "Ayanuru-i",
  "B.beeranahalli",
  "Balekoppa",
  "Bedara Hosahalli",
  "Bidare",
  "Choradi",
  "Gajanuru",
  "Hadonahalli",
  "Haramagatta",
  "Haranahalli",
  "Hasudi",
  "Holaluru",
  "Holebenavalli",
  "Hosahalli",
  "Kadekallu",
  "Kohalli",
  "Kommanalu",
  "Konagavalli",
  "Koralahalli",
  "Koteganguru",
  "Kudli",
  "Kumsi",
  "Kunchenahalli",
  "Mallapura",
  "Mandagatta",
  "Matturu",
  "Melinahanasavadi",
  "Muddinakoppa",
  "Nidige-i",
  "Pillangere",
  "Puradalu",
  "Ramanagara",
  "Santhekaduru",
  "Shettyhalli",
  "Sirigere",
  "Sogane",
  "Suguru",
  "Thammadihalli",
  "Tuppuru",
  "Umblebilu"
]
,
Sorab:[
  "Agasanahalli",
  "Andige",
  "Barangi",
  "Bennur",
  "Bilavalni",
  "Chandragutti",
  "Chitturu",
  "Duguru",
  "Dyavanahalli",
  "Ennekoppa",
  "Gendla",
  "Guduvi",
  "Hanchi",
  "Harishi",
  "Heche",
  "Heggodu",
  "Hosabale",
  "Hurali",
  "Induvalli",
  "Jade",
  "Katuvalli",
  "Kuppagadde",
  "Mavali",
  "Mudi--doddikoppa",
  "Mutuguppe",
  "Nisarani",
  "Nyarsi",
  "Samanavalli",
  "Shakunavalli",
  "Shigga",
  "Talagaddi",
  "Tatturu",
  "Tavanandi",
  "Thelagunda",
  "Udri",
  "Ulavi"
]
,
Tirthahalli:[
  "Agumbe",
  "Araga",
  "Aralasurali",
  "Arehalli",
  "Bandya",
  "Basavani",
  "Bejjavalli",
  "Bidaragodu",
  "Demlapura",
  "Devangi",
  "Guddekoppa",
  "Hadigallu",
  "Hanagere",
  "Harogulige",
  "Hedduru",
  "Heggodu",
  "Hodala-aralapura",
  "Honnetalu",
  "Hosahalli",
  "Hunchadakatte",
  "Kannangi",
  "Konanduru",
  "Kudumallige",
  "Mandagadde",
  "Megaravalli",
  "Melige",
  "Melinakuruvalli",
  "Mulubagilu",
  "Naalur Kolige",
  "Neraturu",
  "Nonaburu",
  "Salgadi",
  "Saluru",
  "Shedgaru",
  "Singinabidre",
  "Thirthamatturu",
  "Triambakapura",
  "Tudur"
],
Ankola:[
  "Achve",
  "Agragone",
  "Agsur",
  "Alageri",
  "Aversa",
  "Bavikeri",
  "Belambar",
  "Belekeri",
  "Belse",
  "Bobruwada",
  "Dongri",
  "Harwada",
  "Hattikeri",
  "Hillur",
  "Honnebailu",
  "Mogta",
  "Sagadgeri",
  "Shetgeri",
  "Sunkasal",
  "Vandige",
  "Vasarakudrige"
]
,
Bhatkal:[
  "Bailur",
  "Belake",
  "Bengre",
  "Hadavalli",
  "Heble",
  "Kaikini",
  "Konar",
  "Koppa",
  "Marukeri",
  "Mavalli",
  "Mavalli-2",
  "Mavinakurve",
  "Mundalli",
  "Mutalli",
  "Shirali",
  "Yelavadikavoor"
]
,
Dandeli:[
  "Alur",
  "Ambewadi",
  "Ambikanagar",
  "Badakanashirada"
]
,
Haliyal:[
  "Aralwad",
  "Belwatgi",
  "Bhagvati",
  "Buzurkanchanalli",
  "Chibbalgeri`",
  "Gundolli",
  "Havagi",
  "Janaga",
  "Kavalwad",
  "Kesarolli",
  "Madnalli",
  "Mangalwad",
  "Modalagera",
  "Murukwad",
  "Nagashettikoppa",
  "Sambrani",
  "Tattigeri",
  "Tatwanagi",
  "Tergaon",
  "Yadoga"
]
,
Honavar:[
  "Balkoor",
  "Chandavar",
  "Chikkankod",
  "Hadinbal",
  "Haldipur",
  "Hereangadi",
  "Hosakuli",
  "Jalvalli",
  "Kadatoka",
  "Kadle",
  "Karki",
  "Kasarkod",
  "Kelginor",
  "Kharwa",
  "Kodani",
  "Kudrigi",
  "Magoda",
  "Manki B (ananthawadi)",
  "Manki C (chithara)",
  "Mavinkurve",
  "Melin Idgunji",
  "Mugwa",
  "Nagarbastikeri",
  "Navilgone",
  "Salkod",
  "Upponi"
]
,
Karwar:[
  "Amdalli",
  "Asnoti",
  "Chendiya",
  "Chittakula",
  "Devalmakki",
  "Ghadsai",
  "Gotegali",
  "Hankon",
  "Kadra",
  "Kadwad",
  "Kerwadi",
  "Kinner",
  "Majali",
  "Mallapur",
  "Mudgeri",
  "Shirwad",
  "Thoduru",
  "Wailwada"
]
,
Kumta:[
  "Alakod",
  "Baad",
  "Bargi",
  "Deevgi",
  "Devagiri",
  "Gokarna",
  "Hanehalli",
  "Hegde",
  "Hiregutti",
  "Holangadde",
  "Kagal",
  "Kalbhag",
  "Kallabbe",
  "Kodakani",
  "Koojali",
  "Mirjan",
  "Murur",
  "Nadumaskeri",
  "Santeguli",
  "Soppinahosalli",
  "Torke",
  "Walgalli"
]
,
Mundgod:[
  "Bachanki",
  "Bedasgaon",
  "Chawdalli",
  "Chigalli",
  "Gunjavati",
  "Hungund",
  "Indoor",
  "Kattur",
  "Kodambi",
  "Mainalli",
  "Malagi",
  "Naganuru",
  "Nandikatta",
  "Onikeri",
  "Pala",
  "Salgaon"
]
,
Siddapur:[
  "Analebail",
  "Bedkani",
  "Bidrakan",
  "Bilgi",
  "Dodmane",
  "Haarsikatta",
  "Halgeri",
  "Hasaragod",
  "Heggarani",
  "Itgi",
  "Kangod",
  "Kavanchoor",
  "Kolsirsi",
  "Korlakai(adukatta)",
  "Kyadagi",
  "Manmane",
  "Nilkund",
  "Shiralgi",
  "Sovinkoppa",
  "Tandagundi",
  "Tarehalli - Kansur",
  "Tyagali",
  "Wajgod"
]
,
Sirsi:[
  "Andagi",
  "Badangod",
  "Banavasi",
  "Bandal",
  "Bankanaal",
  "Bhairumbe",
  "Bhasi",
  "Bisalkoppa",
  "Devanalli",
  "Dodnalli",
  "Guadnapur",
  "Halgadde",
  "Hulekal",
  "Hunasekoppa",
  "Huttagaar",
  "Isalooru",
  "Itguli",
  "Janmane",
  "Kangod",
  "Kodnagadde",
  "Kulave",
  "Malina Onikeri",
  "Manjaguni",
  "Neggu",
  "Sadashivalli",
  "Salkani",
  "Shivalli",
  "Sondha",
  "Sugavi",
  "Unchalli",
  "Vanalli",
  "Yadalli"
]
,
Supa:
[
  "Akheti",
  "Anshi",
  "Asu",
  "Aveda",
  "Bazaar Kulang",
  "Castle Rock (kalamboli)",
  "Gangoda",
  "Jagalbate",
  "Joida",
  "Kateli",
  "Nagoda",
  "Nandigadde",
  "Pradhani",
  "Ramnagar",
  "Shingaragaon",
  "Ulvi"
]
,
Yellapur:[
  "Angod",
  "Chandhaguli",
  "Dehalli",
  "Hasangi",
  "Hithalli",
  "Idgundi",
  "Kampli",
  "Kannigeri",
  "Kirwatti",
  "Kundargi",
  "Madnur",
  "Mavinmane",
  "Nandolli",
  "Ummachagi",
  "Vajralli"
],
// ===== DakshinaKannada District =====

  Bantval: [
    "Alike",
    "Ammunje",
    "Amtadi",
    "Anathadi",
    "Arala",
    "Badagabelluru",
    "Badakajekaru",
    "Balthila",
    "Barimaru",
    "Bolantthuru",
    "Chennaithodi",
    "Golthamajalu",
    "Idkidu",
    "Irvathur",
    "Kadeshwalya",
    "Kallige",
    "Kanyana",
    "Kariangala",
    "Karopadi",
    "Kavalamuduru",
    "Kavalapaduru",
    "Kedila",
    "Kepu",
    "Kolandu",
    "Kukkipadi",
    "Manchi",
    "Mani",
    "Manila",
    "Maninalkur",
    "Meramajalu",
    "Narikombu",
    "Navooru",
    "Netlamudnur",
    "Panjikallu",
    "Peraje",
    "Perne",
    "Peruvai",
    "Pilathabettu",
    "Pudu",
    "Punacha",
    "Rayee",
    "Sajipamooda",
    "Sajipamunnuru",
    "Salethooru",
    "Sangabettu",
    "Sarapadi",
    "Thumbe",
    "Uli",
    "Veerakambha",
    "Vitlamudnuru",
    "Vitlapadnur",
  ],

  Beltangadi: [
    "Aladangadi",
    "Andinje",
    "Arambodi",
    "Arasinamakki",
    "Balanja",
    "Bandaru",
    "Barya",
    "Belalu",
    "Charmadi",
    "Dharmasthala",
    "Hosangady",
    "Ilanthila",
    "Indabettu",
    "Kadirudyavara",
    "Kalanja",
    "Kaliaya",
    "Kalmanja",
    "Kaniyooru",
    "Kashipatna",
    "Kokkada",
    "Koyyuru",
    "Kukkedi",
    "Kuvettu",
    "Laila",
    "Machina",
    "Madanthyaru",
    "Maladi",
    "Malavanthige",
    "Marodi",
    "Melanthabettu",
    "Mithabagilu",
    "Mundaje",
    "Nada",
    "Naravi",
    "Navooru",
    "Neriya",
    "Nidle",
    "Padangadi",
    "Patrame",
    "Puduvettu",
    "Shibaje",
    "Shirlalu",
    "Shishila",
    "Sulkeri",
    "Thannirupantha",
    "Thekkaru",
    "Ujire",
    "Venur",
  ],

  Kadaba: [
    "Aithuru",
    "Alankaru",
    "Balpa",
    "Belanduru",
    "Bilinele",
    "Golithottu",
    "Kadya Konaje",
    "Kaniyuru",
    "Kaukrady",
    "Koila",
    "Kombaru",
    "Kutrupady",
    "Mardhala",
    "Nelyady",
    "Noojibalthila",
    "Perabe",
    "Ramakunja",
    "Savanuru",
    "Shirady",
    "Subrahmanya",
    "Yedamangala",
  ],

  Mangaluru: [
    "Adyar",
    "Badagayedapadavu",
    "Bala",
    "Chelairu",
    "Ganjimata",
    "Gurupura",
    "Jokatte",
    "Kandavara",
    "Kuppepadav",
    "Mallooru",
    "Moodushedde",
    "Muchuru",
    "Muthuru",
    "Neermarga",
    "Paduperar",
    "Permude",
    "Surinje",
    "Ualibettu",
    "Yedapadav",
    "Yekkaru",
  ],

  Mudubidare: [
    "Beluvai",
    "Daregudde",
    "Hosabettu",
    "Iruvail",
    "Kallamundkur",
    "Nellikaru",
    "Padumarnad",
    "Palladka",
    "Putthige",
    "Shirthady",
    "Tenkamijar",
    "Valpadi",
  ],

  Mulki: [
    "Aikala",
    "Athikari Bettu",
    "Balkunje",
    "Haleyangady",
    "Kemral",
    "Kilpady",
    "Padupanambur",
  ],

  Puttur: [
    "Nekkilady",
    "Ariyadka",
    "Aryapu",
    "Badagannuru",
    "Bajathuru",
    "Balnadu",
    "Bannuru",
    "Bettampady",
    "Hirebandady",
    "Kabaka",
    "Kedambady",
    "Keyyur",
    "Kodimbady",
    "Kolthige",
    "Kudippadi",
    "Munduru",
    "Narimogaru",
    "Nettanige Mudnuru",
    "Nidpalli",
    "Panaje",
    "Uppinangady",
    "Volamogaru",
  ],

  Sulya: [
    "Aivarnadu",
    "Ajjavara",
    "Aletti",
    "Amara Mudnuru",
    "Aranthodu",
    "Balila",
    "Bellare",
    "Devachalla",
    "Guthigaru",
    "Harihara Pallathadka",
    "Jalsuru",
    "Kalanja",
    "Kalmadka",
    "Kanaka Majalu",
    "Kodiyala",
    "Kollamogru",
    "Madippady",
    "Mandekolu",
    "Markanja",
    "Murulya",
    "Nelluru Kemraje",
    "Panja",
    "Peruvaje",
    "Sampaje",
    "Ubaradka Mithuru",
  ],

  Ullala: [
    "Amblamogru",
    "Balepuni",
    "Belma",
    "Boliyaru",
    "Harekala",
    "Ira",
    "Kinya",
    "Konaje",
    "Kurnadu",
    "Manjanady",
    "Munnuru",
    "Naringana",
    "Pajiru",
    "Pavuru",
    "Sajipanadu",
    "Sajipapadu",
    "Talapady",
  ],

  // ===== Chikkamagaluru District =====

  Ajjampura: [
    "Anuvanahalli",
    "Attimogge",
    "Baggavalli",
    "Begur",
    "Bukkambudi",
    "Cheeranahalli",
    "Chikkanavangala",
    "Shyanuboganahalli",
    "Gadihalli",
    "Gowrapura",
    "Javoor",
    "Kallenahalli",
    "Koratikere",
    "Mugali",
    "Naranapura",
    "Shivani",
    "Sokke",
    "Sollapura",
    "Tyagadakatte",
  ],

  Chikkamagaluru: [
    "Aldur",
    "Allampura",
    "Amble",
    "Anooru",
    "Avuthi",
    "Basaravalli",
    "Baskal",
    "Beekanahalli",
    "Belavadi",
    "Bidare",
    "Bilekallahalli",
    "Byaravalli (Mallanduru)",
    "Byguru",
    "Dasarahalli",
    "Devadana",
    "Doddamagaravalli",
    "Enam Dattathreyapeeta",
    "Eswarahalli",
    "Hariharadahalli",
    "Hiregouja",
    "Hirekolale",
    "Huyigere",
    "Indavara",
    "K.R.Pete (Bigganahalli Dakale)",
    "Kadavanthi",
    "Kalasapura",
    "Kartikere",
    "Kelagooru",
    "Kuduvalli",
    "Kurubarabudihalu",
    "Lakkammanahalli",
    "Lakya",
    "Machenahalli",
    "Mailimane",
    "Malaloor",
    "Mallenahalli (Bindiga)",
    "Marle",
    "Melina Huluvatthi",
    "Moogthihalli",
    "Mugulavalli",
    "Satthihalli",
    "Shiravase",
    "Sindigere",
    "Thalihalla",
    "Thegur",
    "Thogarihunkal",
    "Vasthare",
  ],

  Kadur: [
    "Anigere",
    "Annegere",
    "Antharagatta",
    "Asandi",
    "Ballekere",
    "Balliganur",
    "Banur",
    "Basur",
    "Biluvala",
    "Bislehalli",
    "Bislere",
    "Cheelanahalli",
    "Chikkaballekere",
    "Chikkadevanur",
    "Chikkangala",
    "Chowlahiriyur",
    "Devanur",
    "Ganganahalli",
    "Garje",
    "Giriyapura",
    "Halikere",
    "Haralagatta",
    "Hirenallur",
    "Hochihalli",
    "Hullehalli",
    "Jiganehalli",
    "Jodihochihalli",
    "Jodithimmapura",
    "K.Bidre",
    "Kadurhalli",
    "Kalkere",
    "Kamanakere",
    "Keresanthe",
    "Kunkanadu",
    "Malleshwara",
    "Mathigatta",
    "Nagarahal",
    "Nagenahalli",
    "Nidghatta",
    "Niduvalli",
    "Panchanahalli",
    "Patnagere",
    "Pillenahalli",
    "Pura",
    "S.Bidre",
    "S.Madapura",
    "Sakrepatna",
    "Saraswathipura",
    "Singatagere",
    "Somanahalli",
    "Tangali",
    "Thimlapura",
    "Udugere",
    "Uligere",
    "V.Yaradakere",
    "Vokkalagere",
    "Y.Mallapura",
    "Yagati",
    "Yellambalse",
    "Yemmedoddi",
  ],

  Kalasa: [
    "Hornadu",
    "Idkani",
    "Kalasa (Mavinakere)",
    "Marasanige",
    "Samse",
    "Thotadur",
  ],

  Koppa: [
    "Agalagandi",
    "Asagodu",
    "Atthikodige",
    "Bhandigadi",
    "Bhuvanakote (Uttameswara)",
    "Binthravalli",
    "Chavalmane",
    "Guddethota",
    "Harandur (Koppa)",
    "Hariharapura",
    "Heruru",
    "Hiregadde",
    "Hirekodige",
    "Jayapura",
    "Kesave",
    "Koppa (Rural)",
    "Marithotlu (Andhagaru)",
    "Narasipura (Narve)",
    "Niluvagilu",
    "Nuggi (Bappunji)",
    "Shanuvalli",
    "Tuluvinakoppa (Kalkere)",
  ],

  Mudigere: [
    "B.Bosahalli (Bharatibylu)",
    "Balur",
    "Banakal",
    "Bettagere",
    "Bidarahalli",
    "Chinniga",
    "Coove",
    "Daradahalli",
    "Gonibeedu",
    "Halemudigere",
    "Hanthuru",
    "Hesagal (Belagola)",
    "Javali",
    "Kirugunda",
    "Kundur",
    "Makonahalli",
    "Nandipura",
    "Niduvale",
    "Phalguni",
    "Sunkasale",
    "Taruve",
    "Tripura",
    "Urubage",
  ],

  Narasimharajapura: [
    "Aduvalli (Gadigeshwara)",
    "B.Kanabur (Balehonnur)",
    "Bale (Mudabagilu)",
    "Bannur",
    "Gubbiga",
    "Honnekudige (Hanthuvine)",
    "Kadahinabylu",
    "Kanur",
    "Karekeshwara (Melpal)",
    "Magundi",
    "Mensur",
    "Muthinakoppa",
    "Nagalapura (G.H.Kaimara)",
    "Seethur",
  ],

  Sringeri: [
    "Addagadde",
    "Begaru",
    "Dharekoppa",
    "Kere",
    "Kuthagodu",
    "Markal (Kigga)",
    "Menase",
    "Nemmaru",
    "Vidyaranayapura",
  ],

  Tarikere: [
    "Amruthapura",
    "Baragenahalli",
    "Belenahalli",
    "Bettadahalli",
    "Bhavikere",
    "Doranalu",
    "Gopala",
    "Gulladamane",
    "Hadikere",
    "Halasur",
    "Hunasaghatta",
    "Kamanadurga",
    "Karkuchi",
    "Kenchikoppa",
    "Koranahalli",
    "Kudlur",
    "Lakkavalli",
    "Lingadahalli",
    "Malalichannenahalli",
    "Mudugodu",
    "Nandi Battlu",
    "Nerlekere",
    "Siddarahalli",
    "Sunnadahalli",
    "Thigada",
    "Udeva",
  ],

  // ===== Hassan District =====

  Alur: [
    "Abbana",
    "Byarapura",
    "Dodda Kanagal",
    "Ganjigere",
    "Hanchur",
    "Hunasavalli",
    "Kadalu",
    "Kanathur",
    "Karagodu",
    "Kunduru",
    "Madabalu",
    "Magge",
    "Mallapura",
    "Palya",
    "Taluru",
  ],

  Arkalgud: [
    "Agrahara",
    "Aladahalli",
    "Bannur",
    "Basavapatna",
    "Belavadi",
    "Bychanahalli",
    "Chikkanahalli",
    "Dodda Bemmathi",
    "Dodda Magge",
    "Gangoor",
    "Ganjalagodu",
    "Handrangi",
    "Hanyalu",
    "Hebbale",
    "Heggadihalli",
    "Holalagodu",
    "Honnavalli",
    "Hulikallu",
    "Kaduvinahosahalli",
    "Kalenahalli",
    "Kattepura",
    "Katti Mallenahalli",
    "Keralapura",
    "Konanur",
    "Koratikere",
    "Lakkur",
    "Mallipatna",
    "Mokali",
    "Ramanathapura",
    "Rudrapatna",
    "Santhemarur",
    "Saragoor",
    "Tarigalale",
    "Vaddarahalli",
    "Vijapura Forest",
    "Yalagathavalli",
  ],

  Arsikere: [
    "Aggunda",
    "Arakere",
    "Bageshpura",
    "Bagivalu",
    "Banavara",
    "Bandur",
    "Belagumba",
    "Bendekere",
    "Chogachagere",
    "Doddametikurke",
    "Dummenahalli",
    "Gandasi",
    "Geejihalli",
    "Habbanaghatta",
    "Handralu",
    "Harnahalli",
    "Heggatta",
    "Hiriyur",
    "Jajur",
    "Javagal",
    "Jayachamarajapura",
    "Kachighatta",
    "Kallugundi",
    "Kalyadi",
    "Kamasamudra",
    "Kanakatte",
    "Karagunda",
    "Kenkere",
    "Kolagunda",
    "Kondenalu",
    "Kuruvanka",
    "Lalanakere",
    "Madalu",
    "Mududi",
    "Murundi",
    "Narasipura",
    "Nerlige",
    "Puralehalli",
    "Rampura",
    "Rangapura",
    "Shanegere",
    "Shankaranahalli",
    "Thalalur",
    "Undiganalu",
    "Yadavanahalli",
  ],

  Belur: [
    "Adagooru",
    "Andale",
    "Anughatta",
    "Arehalli",
    "Bantenahalli",
    "Bichodu",
    "Chatchatnahalli",
    "Cheekanahalli",
    "Chikkamedur",
    "Dabbe",
    "Gangur",
    "Ghattadahalli",
    "Gonisomenahalli",
    "Hagare",
    "Halebeedu",
    "Hanike",
    "Hebbalu",
    "Hulugundi",
    "Hunuganahalli",
    "Ibbedu",
    "Kalleri",
    "Kesagodu",
    "Kodihalli",
    "Kogilamane",
    "Kushavara",
    "Lakkunda",
    "Madaghatta",
    "Malasavara",
    "Narayanapura",
    "Narvepete",
    "Rajanasiriyur",
    "Sanyasihalli",
    "Savasihalli",
    "Tholalu",
    "Thumbudevanahalli",
    "Yalahanka",
    "Yamasandi",
  ],

  Channarayapatna: [
    "Akkanahalli",
    "Anathi",
    "Anekere",
    "Bagur",
    "Baladare",
    "Balaganchi",
    "Baragur",
    "Bekka",
    "Belagihallli",
    "Byadarahalli",
    "D.kalenahalli",
    "Dammaninagala",
    "Didaga",
    "Dindagur",
    "Gowdagere",
    "Gulasinda",
    "Hirisave",
    "Jambur",
    "Janivara",
    "Jinnenahalli",
    "Juttanahalli",
    "Kabbali",
    "Kabbalu",
    "Kalkere",
    "Kantharajapura",
    "Karehalli",
    "Kembalu",
    "Kumbenahalli",
    "Kundur",
    "M.shivara",
    "Mathigatta",
    "Mattanavile",
    "Nallur",
    "Navile",
    "Noranakki",
    "Nuggehalli",
    "S.shivara",
    "Sathenahalli",
    "Sravanabelagola",
    "Sundahalli",
    "Tagadur",
  ],

  Hassan: [
    "A.hosahalli",
    "Ambuga",
    "Ankapura",
    "B.katihalli",
    "Basavagatta",
    "Boovanahalli",
    "Bylahalli",
    "Channangihalli",
    "Doddagenigere",
    "Dudda",
    "Gadenahalli",
    "Gorur",
    "Hanumanthapura",
    "Haralahalli",
    "Heragu",
    "Honnavara",
    "Huvinahalli Kaval",
    "Jagaravalli",
    "Kabbali",
    "Kandali",
    "Karle",
    "Kattaya",
    "Koravangala",
    "Kowsika",
    "Kuduragundi",
    "Madenur",
    "Manacanahalli",
    "Markuli",
    "Melagodu",
    "Mosalehosahalli",
    "Nittur",
    "Salagame",
    "Sathyamangala",
    "Seege",
    "Shankaranahalli",
    "Shantigrama",
    "Shettihalli",
    "Tejur",
    "Thattekere",
    "Ugane",
    "Yalagunda",
  ],

  Holenarsipur: [
    "Anekannambadi",
    "Bagivalu",
    "Bidarakka",
    "Doddabyagathavalli",
    "Doddahalli",
    "Doddakadanur",
    "Doddakunche",
    "Halekote",
    "Halli Mysore",
    "Hangarahalli",
    "Hariharapura",
    "Ichanahalli",
    "Kattebelaguli",
    "Keragodu",
    "Kodihalli",
    "Kyathanahalli",
    "Malali",
    "Mallappanahalli",
    "Moodalahippe",
    "Nagaranahalli",
    "Niduvani",
    "Odanahalli",
    "Paduvalahippe",
    "Sankanahalli",
    "Sravanur",
    "Thathanahalli",
  ],

  Sakaleshpur: [
    "Anemahal",
    "Bage",
    "Ballu",
    "Belagodu",
    "Biradahalli",
    "Byakaravalli",
    "Changadihalli",
    "Devaladakere",
    "Halasulige",
    "Hanbal",
    "Hebbasale",
    "Heggadde",
    "Hethur",
    "Hongadahalla",
    "Hosur",
    "Igoor",
    "Kuniganahalli",
    "Kurubathur",
    "Kyamanahalli",
    "Kyanahalli",
    "Malali",
    "Uchangi",
    "Udevara",
    "Valalahalli",
    "Vanagoor",
    "Yeslur",
  ],

  // ===== Kodagu District =====

  Kushalanagar: [
    "7th Hoskote",
    "Chettalli",
    "Guddehosur",
    "Hebbale",
    "Kambibane",
    "Kedakal",
    "Kodagaralli",
    "Kudige",
    "Kudumangalore",
    "Mullusoge",
    "Nakur Sirangala",
    "Nanjarayapatna",
    "Nelliyahaudikeri",
    "Sirangala",
    "Sunticoppa",
    "Torenur",
    "Valnur Thyagathur",
  ],

  Madikeri: [
    "Aiyamgeri",
    "Ballamavati",
    "Bengoor Cherambane",
    "Bettageri",
    "Bhagamandala",
    "Chembu",
    "Galibeedu",
    "Hakathur",
    "Hoddur",
    "Hosakeri",
    "Kadagadalu",
    "Kalakeri Nidugane",
    "Kanthur Murnad",
    "Karike",
    "Konanjageri (Perane)",
    "Kundacheri",
    "Kunjila (Kakkabbe)",
    "Made",
    "Makkandur",
    "Maragodu",
    "Mekeri",
    "Napoklu",
    "Nariandada",
    "Peraje",
    "Sampaje",
    "Yammemadu",
  ],

  Ponnampet: [
    "Aruvatoklu",
    "B. Shettigeri",
    "Balele",
    "Balyamandur",
    "Birunani",
    "Devarapura",
    "Hathur",
    "Hudikeri",
    "K.badaga",
    "Kanur",
    "Kirgur",
    "Kutta",
    "Mayamudi",
    "Nalkeri",
    "Nittur",
    "Ponnampet",
    "Ponnappasanthe",
    "Srimangala",
    "T. Shettigeri",
    "Thithimathi",
  ],

  Somvarpet: [
    "Aigur",
    "Alur",
    "Bedagotta",
    "Belur",
    "Besur",
    "Bettadalli",
    "Chowdlu",
    "Doddamolathe",
    "Dundalli",
    "Ganagur",
    "Garuvale",
    "Gowdalli",
    "Hanagallu",
    "Handli",
    "Haradur",
    "Kirgandur",
    "Kodlipet",
    "Madapura",
    "Nerugalale",
    "Nidta",
    "Shanivarasanthe",
    "Shanthalli",
    "Tholur Shettalli",
  ],

  Virajpet: [
    "Ammathi",
    "Arji",
    "Betoli",
    "Bilugunda",
    "Bittangala",
    "Chembe Bellur",
    "Chennayana Kote",
    "Gonikoppal",
    "Halugunda",
    "Hosur",
    "Kadanur",
    "Kakotuparambu",
    "Kannangala",
    "Karmadu",
    "Kedamullur",
    "Maldare",
    "Polibetta",
    "Siddapura",
  ]



};

// Small helpers to keep component code clean and avoid undefined errors
export const getDistrictsByState = (state) =>
  STATE_DISTRICTS[state] || [];

export const getTaluksByDistrict = (district) =>
  DISTRICT_TALUKS[district] || [];

export const getPanchayatsByTaluk = (taluk) =>
  TALUK_PANCHAYATS[taluk] || [];